var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCasa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 52,
    viewBox: "0 0 62 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.8465 26.1303C55.848 30.4964 54.6986 34.7857 52.5142 38.566M43.4108 47.6679C39.6299 49.8508 35.3409 51 30.9751 51C26.6092 51 22.3203 49.8508 18.5394 47.6679C14.7584 45.485 11.6187 42.3453 9.43574 38.5644C7.25279 34.7834 6.10355 30.4945 6.10352 26.1287",
    stroke: "#4A8FB7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.975 37.5946C37.3977 37.5946 42.6043 32.388 42.6043 25.9653C42.6043 19.5426 37.3977 14.336 30.975 14.336C24.5523 14.336 19.3457 19.5426 19.3457 25.9653C19.3457 32.388 24.5523 37.5946 30.975 37.5946Z",
    stroke: "#4A8FB7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5925 44.8916C49.2606 44.8916 49.8022 44.35 49.8022 43.6819C49.8022 43.0138 49.2606 42.4722 48.5925 42.4722C47.9244 42.4722 47.3828 43.0138 47.3828 43.6819C47.3828 44.35 47.9244 44.8916 48.5925 44.8916Z",
    stroke: "#4A8FB7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 18.4197L30.9749 1L60.9497 18.4197",
    stroke: "#4A8FB7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasa);
export default __webpack_public_path__ + "static/media/casa.ac36daa603952718ea3d9fd5cdafa756.svg";
export { ForwardRef as ReactComponent };